import styled from 'styled-components';

export const Label = styled.label`
	color: ${p => p.theme.colors.neutralLightest};
	font-weight: 400;
	display: flex;
	align-items: center;
	gap: ${p => p.theme.styles.padding}px;
`;